import {StorageUtil} from "../infra/storageUtil.service";
var angular:angular.IAngularStatic =  require('angular');
import {Component, Inject} from 'ng-metadata/core';
import {UserSessionManagerService} from '../security/userSessionManager.service';

import {MediaQueries} from '../infra/mediaQueries.service';
import {getSessionTimeoutParams} from '../appConfig/appConfigForward';
import {PrimoExploreService} from './primoExplore.service';
import {JwtUtilService} from '../security/jwtUtil.service';
import {STATE_NAMES} from "./primoExploreStates.module";
import { CMIntegrationService } from "../cm_integration.service";

@Component({
	selector: 'primo-explore',
	template: `<div ui-view></div><prm-explore-footer ng-if="!$ctrl.isEmailTemplateState()"></prm-explore-footer><prm-silent-login></prm-silent-login><prm-login-iframe></prm-login-iframe>`
})

export class PrimoExplore {
	private warningShowed: boolean;
	private alertObject: angular.material.IDialogOptions;
	private responsiveClass :string;
	private graceTime = getSessionTimeoutParams().warningTime * 1000;

	constructor(private primoExploreService: PrimoExploreService,
				@Inject('Idle') private Idle: angular.idle.IIdleService,
				private userSessionManagerService: UserSessionManagerService,
				@Inject('$element') private $element: ng.IAugmentedJQuery,
				@Inject('$mdDialog') private $mdDialog:  angular.material.IDialogService,
				@Inject('$scope') private $scope: ng.IScope,
				@Inject('$timeout') private $timeout: ng.ITimeoutService,
				@Inject('$translate') private $translate: ng.translate.ITranslateService,
				@Inject('$window') private $window: ng.IWindowService,
				@Inject('$state') private $state: ng.ui.IStateService,
				private jwtUtilService: JwtUtilService,
				private mediaQueries: MediaQueries,
				private storageutil: StorageUtil,
				private cmIntegrationService: CMIntegrationService) {

		//fixes bug with ui-router not switching state due to "transition superseded"
		$scope.$on('$stateChangeCancel',(event, toState, toParams, fromState, fromParams) => {
			if (toState.name === STATE_NAMES.COLLECTION_DISCOVERY){
				console.log('state transition canceled retrying!');
				$timeout(()=>{
					this.$state.go(toState, toParams, {reload: true, inherit:false});
				}, 0)
			}
		});


		$scope.$on('IdleWarn',  () => this.handleWarning());
		this.warningShowed = false;
		this.userSessionManagerService = userSessionManagerService;
		this.$mdDialog = $mdDialog;
		this.$window = $window;
		this.updateResponsiveClass();
		angular.element($window).bind('resize', () => this.$timeout(()=> this.updateResponsiveClass(),0,false));

		$translate(['nui.session.timeout.button','nui.session.timeout.alert', 'nui.session.timeout.attention']).then((translations)=> {
			this.alertObject = $mdDialog.alert({
				textContent: translations['nui.session.timeout.alert'],
				ok:translations['nui.session.timeout.button'],
				title: translations['nui.session.timeout.attention']
			});
		});

	}

	$postLink() {
		this.cmIntegrationService.ready();
	}

	public isEmailTemplateState() {
        return this.$state.current.name === STATE_NAMES.EMAIL_TEMPLATE;
	}

	private updateResponsiveClass() {
		let newClass = this.mediaQueries.createDynamicClass();
		if(newClass === this.responsiveClass) {
			return;
		}

		if(this.responsiveClass) {
			this.$element.removeClass(this.responsiveClass);
		}
		this.responsiveClass = newClass;
		this.$element.addClass(this.responsiveClass);
	}

	private handleWarning() {
		this.userSessionManagerService.logout(true);
	}

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/primoExplore.directive.ts